const settings = {
  // How many different dispatched actions determine loading progress
  // This is likely determined by how many dispatched actions you have below
  // in the created() method
  LOADING_SEGMENTS: 2,
  API_BASE_PATH: "/wp-json/wp/v2/",
  THEME_DIRECTORY_NAME: "seisouka",
}

module.exports = settings;
